module.exports = __webpack_public_path__ + "img/epicycloid_info_dezarg.6a4ddeb9.jpeg";